/**
 * @name ApplicationsService
 * @description Servicio para la gestión de las aplicaciones de Talentry
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Notificación Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta una colección de aplicaciones que tiene la empresa
 * El administrador de empresa puede consultar este servicio
 * @returns {any} promise
 */
const getRelationByEnterprise = () => {
  let URL = `${BASE_URL}/AplicacionEmpresa?paginado=0,100`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta una colección de aplicaciones que tiene el empleado
 * Cualquier usuario con acceso a Talentry puede consultar este servicio
 * @param {any} request filter { idEmpleado, idAplicacion, permisoEspecial, columnas }
 * @returns {any} promise
 */
const getRelationByEmployee = (request) => {
  let employeeId = !request.filter.employeeId ? '' : `&idEmpleado=${request.filter.employeeId}`;
  let applicationId = !request.filter.applicationId ? '' : `&idAplicacion=${request.filter.applicationId}`;
  let specialPermission = !request.filter.specialPermission ? '' : `&permisoEspecial=${request.filter.specialPermission}`;
  let columns = request.columns === null ? '' : `&columnas=${request.columns}`;

  let URL = `${BASE_URL}/AplicacionEmpleado?paginado=0,100${employeeId}${applicationId}${specialPermission}${columns}`;

  return axios.get().then(URL).then(({ data }) => {
    return data;
  });
};

export const ApplicationsService = {
  getRelationByEnterprise,
  getRelationByEmployee
};